import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core';

import 'moment/locale/es';
import moment from 'moment';

import Datatable from '../../../shared/ui/components/Datatable';
import getBillingInvoiceList from 'src/billing/use-cases/getBillingInvoiceList';

const useStyles = makeStyles((theme) => ({
  customerAccountStatus: {
    paddingBottom: theme.spacing(3)
  }
}));

const BillingDatatable = ({
  customerId,
  handleDownload,
  handleAdd,
  handleEdit,
  handleClickExportExcel
}) => {
  const companyHeadquarterId = localStorage.selectedUserHeadquarter;
  const classes = useStyles();
  const user = JSON.parse(localStorage.user);
  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const fetchList = async () => {
    const response = await getBillingInvoiceList({
      companyHeadquarterId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    response.rows = response.rows.map((x) => {
      let monthNameTermList = {
        monthNameTermList: Array.from(
          new Set(
            x.customerTermList.map((y) =>
              moment(y.date)
                .format('MMMM')
                .toUpperCase()
            )
          )
        ).join(' ')
      };

      return {
        ...x,
        ...monthNameTermList
      };
    });

    setList(response);
  };

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickDownload = (event, id) => {
    handleDownload(id);
  };

  const columnNameList = [
    'date',
    'invoiceStampingNumber',
    'number',
    'monthNameTermList|date',
    'CustomerInvoiceStatus.code',
    'hasPaymentsValidated',
    'type',
    "${'CL'}${HeadquarterCustomer.customerCode}",
    'billToCustomerContact.zoneCode',
    'HeadquarterCustomer.businessName,LINK:/app/customers/:headquarterCustomerId',
    '${billToCustomerContact.firstname}${billToCustomerContact.surnames}|billToCustomerContact.firstname',
    'billToCustomerContact.document',
    'billToCustomerContact.phone1',
    '${MoneyCollectionCustomerContact.firstname}${MoneyCollectionCustomerContact.surnames}|MoneyCollectionCustomerContact.firstname',
    'MoneyCollectionCustomerContact.phone1',
    'MoneyCollectionCustomerContact.paymentTypeNameList|MoneyCollectionCustomerContact.paymentTypeListId',
    'PromisePayment.promiseDate',
    'hasValidPromisePayment',
    'MoneyCollectionCustomerContact.preferredPaymentDay',
    'scheduledPaymentDate',
    'comments',
    'amount',
    'rest'
  ];

  if (localStorage.selectedUserHeadquarter === 'all') {
    columnNameList.unshift('CompanyHeadquarter.name');
  }

  return (
    <Datatable
      domainName="CUSTOMER_INVOICE"
      dataList={list.rows}
      count={list.count}
      addButtonText=""
      addButtonRoute={false}
      title="Facturas"
      exportExcelButton={user?.scopes.includes('admin:billing')}
      onSearch={handleSearch}
      onChangePageValue={handleChangePage}
      onChangePageLimit={handleChangeLimit}
      handleOrderBy={handleOrderBy}
      handleClickAdd={() => {}}
      handleClickEdit={handleEdit}
      handleClickDownload={handleClickDownload}
      handleClickExportExcel={handleClickExportExcel}
      columnNameList={columnNameList}
    />
  );
};

export default BillingDatatable;
